// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bgy_a bhn_h","Menu__offsetParent":"bgy_b bhn_bj","Menu__trigger--shadowed":"bgy_c"};